import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, isAuthenticated, isSignedIn, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated || isSignedIn ? <Component {...props} /> : <Redirect to="/" />
        }
    />
);

const mapStateToProps = ({ auth }) => auth;
export default connect(
    mapStateToProps,
    null
)(PrivateRoute);
